import * as Sentry from '@sentry/vue'

export default (app: object, tag: string, router?: object) => {
    if (process.env.NODE_ENV !== 'production') {
        return
    }

    if (localStorage.getItem('nosentry')) {
        return
    }

    if (window.location.search.substr(1) === 'nosentry') {
        localStorage.setItem('nosentry', 'true')
        window.history.replaceState(null, '', window.location.pathname)
        return
    }
    const integrations = []

    if (router) {
        // @ts-expect-error internal sentry 'VueRouter' type
        integrations.push(Sentry.browserTracingIntegration({ router }))
    }

    Sentry.init({
        // @ts-expect-error internal sentry "Vue' type
        app,
        dsn: 'https://a21682872eca4e9d9b4d5e7eff78d14f@o456033.ingest.sentry.io/5448696',
        integrations,
        ignoreErrors: [
            /Network Error/i,
            /Fetch Error/i,
            /XHR Error/i,
            /Failed to fetch/i,
            /createRouterError/i,
        ],
        beforeSend (event, hint) {
            console.log('event', event)
            console.log('hint', hint)
            if (
                typeof hint.originalException === 'object'
                && hint.originalException != null
                && 'key' in hint.originalException
            ) {
                event.extra = {
                    ...event.extra,
                    ...hint.originalException,
                }
            }
            return event
        },
        normalizeDepth: 8,
    })

    Sentry.setTag('app', tag)
}
